// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leveled{z-index:10;position:relative}.appheader,.head-name{z-index:100;position:relative}.slide-leave-active{transition:opacity .5s ease;opacity:0;animation:slide-out .5s ease-out forwards}.slide-leave{opacity:1;transform:translateX(0)}.slide-enter-active{animation:slide-in .7s ease-out forwards}@keyframes slide-out{0%{transform:translateY(0)}100%{transform:translateY(500px)}}@keyframes slide-in{0%{transform:translateY(-250px)}100%{transform:translateY(0)}}", ""]);
// Exports
module.exports = exports;
